// 乌克兰语
import common from "./uk-UK/common"
import home from "./uk-UK/home"
import query from './uk-UK/query'
import track from './uk-UK/track'
import contact from './uk-UK/contact'
import about from './uk-UK/about'

export default {
    ...common,
    ...home,
    ...about,
    ...query,
    ...track,
    ...contact
}